var _defs, _ellipse, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sign_up",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 40.45px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #004d77;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        fill: #1e938d;\n      }\n\n      .cls-4, .cls-5, .cls-2, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-5 {\n        fill: #2bbbb2;\n      }\n\n      .cls-3 {\n        stroke-width: 20.02px;\n      }\n\n      .cls-8 {\n        clip-path: url(#sign_out__clippath);\n      }\n\n      .cls-6 {\n        fill: #d3d8da;\n      }\n\n      .cls-7 {\n        fill: #004d77;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "sign_out__clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 485.6,
    cy: 470.8,
    r: 286.5
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 474.1,
    cy: 948.9,
    rx: 388.7,
    ry: 77
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Hair"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M521.7,80.9c-.3,18.2-13.7,33.1-31.2,35.8l-1.5,104c0,3.3-2.8,6-6.2,6s-6-2.8-6-6.2l1.5-104c-17.3-3.2-30.3-18.5-30-36.7.3-20.3,17-36.5,37.3-36.2,20.2.3,36.4,17,36.1,37.3Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Back_Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M502.2,803.7c0,9.2-7.4,16.6-16.6,16.6s-16.6-7.4-16.6-16.6c0-7,4.3-13,10.5-15.4v-102.6c0-3.4,2.7-6.1,6.1-6.1s6.1,2.7,6.1,6.1v102.7c6.2,2.4,10.5,8.4,10.5,15.3Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M822.5,377.7c-34.2,0-62-27.8-62-62v-145.7c0-34.2,27.8-62,62-62h119.4c34.2,0,62,27.8,62,62v145.7c0,34.2-27.8,62-62,62h-119.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M941.9,117.9c28.7,0,52,23.3,52,52v145.7c0,28.7-23.3,52-52,52h-119.4c-28.7,0-52-23.3-52-52v-145.6c0-28.7,23.3-52,52-52h119.4M941.9,97.9h-119.4c-39.7,0-72,32.3-72,72v145.7c0,39.7,32.3,72,72,72h119.4c39.7,0,72-32.3,72-72v-145.6c.1-39.8-32.3-72.1-72-72.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M885.1,121.8c0,15.8-12.8,28.6-28.6,28.6h-29v29c0,15.8-12.8,28.6-28.6,28.6s-28.6-12.8-28.6-28.6v-29h-17.2c8.5-30.3,36.4-52.5,69.4-52.5h49.7c7.8,5.1,12.9,13.9,12.9,23.9Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 741.4,
    y1: 121.8,
    x2: 856.5,
    y2: 121.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 799,
    y1: 64.3,
    x2: 799,
    y2: 179.4
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 863,
    y1: 189.3,
    x2: 962.3,
    y2: 189.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.5,
    y1: 249.8,
    x2: 961.9,
    y2: 249.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 806.5,
    y1: 309.9,
    x2: 961.9,
    y2: 309.9
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "sign_out__R_Leg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Feet"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M720.5,921.2c0,12.9,10.5,23.4,23.4,23.4s23.4-10.5,23.4-23.4c0-8.7-4.7-16.3-11.8-20.3l17.8-189.2c.5-5.3-3.4-10-8.7-10.5s-10,3.4-10.5,8.7l-17.8,189.2c-9.2,3.2-15.8,11.9-15.8,22.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Leg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M662.2,650.4l69.5,49.5c-1.2,3.4-1.8,7.1-1.8,11,0,18.7,15.2,33.9,33.9,33.9s33.9-15.2,33.9-33.9-15.2-33.9-33.9-33.9c-7.9,0-15.1,2.7-20.8,7.2l-69.5-49.5c-4.3-3.1-10.4-2.1-13.5,2.3-3.2,4.3-2.2,10.3,2.2,13.4Z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "sign_out__L_Leg"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Feet-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M255.6,921.2c0,12.9-10.5,23.4-23.4,23.4s-23.4-10.5-23.4-23.4c0-8.7,4.7-16.3,11.8-20.3l-17.8-189.2c-.5-5.3,3.4-10,8.7-10.5s10,3.4,10.5,8.7l17.8,189.2c9.2,3.2,15.8,11.9,15.8,22.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Leg-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M314,650.4l-69.5,49.5c1.2,3.4,1.8,7.1,1.8,11,0,18.7-15.2,33.9-33.9,33.9s-33.9-15.2-33.9-33.9,15.2-33.9,33.9-33.9c7.9,0,15.1,2.7,20.8,7.2l69.5-49.5c4.3-3.1,10.4-2.1,13.5,2.3,3.1,4.3,2.1,10.3-2.2,13.4Z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "sign_out__finomate"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Body"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 485.6,
    cy: 470.8,
    r: 286.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Shadow"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.1,297.6c-5.7,173.3,108.3,322.3,260.7,356,121.3,26.8,251.9-22.7,335.1-125.9,37.2,60.5,85.3,159.3,50.3,239.8-87.1,200.3-671.7,245.5-791.2,4.8-63.4-127.8,12.9-318.8,145.1-474.7Z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "sign_out__L_Hand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Leg-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M414.5,696.3l-72.3,80.9c4.4,6.1,7,13.6,7,21.8,0,20.6-16.7,37.3-37.3,37.3s-37.3-16.7-37.3-37.3,16.7-37.3,37.3-37.3c5.4,0,10.6,1.2,15.3,3.3l72.8-81.5c3.5-4,9.7-4.3,13.6-.8,4.1,3.5,4.4,9.6.9,13.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Feet-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M381.1,975.8c0,14.4-11.7,26.1-26.1,26.1s-26.1-11.7-26.1-26.1c0-8.6,4.2-16.3,10.7-21l-37-156c-1.2-5.2,2-10.4,7.2-11.6,5.2-1.2,10.4,2,11.6,7.1l37,155.6c12.7,1.6,22.7,12.6,22.7,25.9Z"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "sign_out__R_Hand"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Leg-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M721,584.4l106.8-19.2c2.9,7,7.9,13.1,14.9,17.4,17.5,10.8,40.5,5.3,51.3-12.2s5.3-40.5-12.3-51.2-40.5-5.3-51.2,12.2c-2.9,4.6-4.6,9.7-5.2,14.7l-107.6,19.4c-5.2.9-8.7,6-7.8,11.2.9,5.1,5.9,8.6,11.1,7.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Feet-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M921.6,380.2c-.1-14.4-11.9-26-26.3-25.8-14.4.1-26,11.9-25.8,26.3.1,8.6,4.4,16.2,10.9,20.9l-35.6,156.4c-1.2,5.2,2.1,10.4,7.3,11.5,5.2,1.2,10.4-2.1,11.5-7.3l35.4-155.9c12.9-1.7,22.7-12.8,22.6-26.1Z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "sign_out__Eye"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M488.7,582.9c-96.7,0-175.4-78.7-175.4-175.4s78.7-175.3,175.4-175.3,175.4,78.7,175.4,175.4-78.7,175.3-175.4,175.3ZM488.7,274.4c-73.4,0-133.1,59.7-133.1,133.1s59.7,133.1,133.1,133.1,133.2-59.6,133.2-133-59.8-133.2-133.2-133.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 488.7,
    cy: 407.6,
    r: 116.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 548.3,
    cy: 380.5,
    r: 55.1,
    transform: "translate(84.89 860.77) rotate(-80.78)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUp);
export default __webpack_public_path__ + "static/media/sign_up.6ef722af5b4a24b5d520c4a63554b48a.svg";
export { ForwardRef as ReactComponent };